<template>

    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Города доставки</h3>
                        <div class="card-toolbar">
                            <b-button @click="addCityShow" variant="primary">Добавить город</b-button>
                        </div>
                    </div>
                    <div class="card-body pt-0">

                        <div v-if="cities.length === 0" class="text-center mb-10">
                            Города не найдены!
                        </div>

                        <div v-if="load" class="text-center mb-10">
                            <b-spinner variant="primary" label="Text Centered"></b-spinner>
                        </div>

                        <b-form v-else>

                            <!--begin::Table-->
                            <div  class="table-responsive mt-3">
                                <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_4">
                                    <thead>
                                    <tr class="text-left">
                                        <th class="pl-0">Город</th>
                                        <th class="pr-0 text-right">Действия</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <template v-for="(city, i) in cities">
                                        <tr v-bind:key="i">
                                            <td class="pl-0">
                                                <div class="d-flex align-items-center">
                                                    <div>
                                                        <a @click="editCity(city)" href="javascript:void(0)" class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{city.name}}</a>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="pr-0 text-right">
                                                <b-button @click="editCity(city)" v-b-tooltip.hover title="Редактировать" class="btn btn-icon btn-light btn-hover-primary btn-sm"><i class="fas fa-edit"></i></b-button>
                                                <b-link @click="showDelete(city)" v-b-tooltip.hover title="Удалить" class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"><i class="fas fa-trash-alt"></i></b-link>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                            <!--end::Table-->
                            <Paginate :route_link="'Accounts'" :filter="filter" />

                        </b-form>

                    </div>
                </div>
            </div>
        </div>

        <b-modal ref="delete-modal" centered hide-footer hide-header title="Подтвердите действие">
            <div class="d-block text-center">
                <h3>Удалить город: {{modalCity.name}}?</h3>
            </div>
            <b-row>
                <b-col>
                    <b-button class="mt-3" variant="outline-primary" @click="closeModal" block >Отмена</b-button>
                </b-col>
                <b-col>
                    <b-button ref="del-city" class="mt-3" variant="outline-danger" @click="deleteCity" block >Удалить</b-button>
                </b-col>
            </b-row>

        </b-modal>


        <b-modal ref="edit-city" centered hide-footer :title="titleModal()">
            <div class="d-block">

                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите название города" label="Имя:">
                        <b-form-input v-model.trim="city.name" :class="{'is-invalid': errors.name}" required></b-form-input>
                        <div v-if="errors.name" class="invalid-feedback">{{errors.name[0]}}</div>
                    </b-form-group>
                </div>



                <div class="card card-custom card-stretch gutter-b">

                    <!--begin::Header-->
                    <div class="card-header border-0 py-5">
                        <h3 class="card-title align-items-start flex-column">
                            <span class="card-label font-weight-bolder text-dark">Добавить метод доставки</span>
                        </h3>
                    </div>
                    <!--end::Header-->
                    <div class="card-body pt-0 pb-3">

                        <div class="form-group mb-2">
                            <b-form-group class="mb-2" description="Например: Авиа" label="Название метода:">
                                <b-form-input v-model.trim="method.name" :class="{'is-invalid': errorNameMethod}"></b-form-input>
                                <div v-if="errorNameMethod" class="invalid-feedback">Обязательное поле</div>
                            </b-form-group>
                        </div>

                        <div class="form-group mb-2">
                            <b-form-group class="mb-2" description="Например: 15" label="Срок по умолчанию (дни):">
                                <b-form-input v-model.number="method.days"></b-form-input>
                            </b-form-group>
                        </div>

                      <div class="form-group mb-2">
                        <b-form-group class="mb-2" description="Значение по умолчанию (В долларах)" label="Логистика КНР:">
                          <b-form-input v-model.number="method.knr"></b-form-input>
                        </b-form-group>
                      </div>

                      <div class="form-group mb-2">
                        <b-form-group class="mb-2" description="Значение по умолчанию (В долларах)" label="Логистика КНРРФ:">
                          <b-form-input v-model.number="method.knrrf"></b-form-input>
                        </b-form-group>
                      </div>

                      <div class="form-group mb-2">
                        <b-form-group class="mb-2" description="Значение по умолчанию (В долларах)" label="ТП:">
                          <b-form-input v-model.number="method.tp"></b-form-input>
                        </b-form-group>
                      </div>

                      <div class="form-group mb-2">
                        <b-form-group class="mb-2" description="Значение по умолчанию (В долларах)" label="Логистика РФ:">
                          <b-form-input v-model.number="method.rf"></b-form-input>
                        </b-form-group>
                      </div>

                      <b-button ref="add_methods" class="mt-3" variant="primary" block @click="addMethod">Добавить метод</b-button>

                        <div v-bind:key="i" v-for="(method, i) in city.methods" class="row align-items-center mb-3 mt-5 role mx-0">
                            <div  class="col-lg-12 col-xl-12">
                                <div class="row align-items-center">
                                    <div class="col-md-6 my-2 my-md-0">
                                        <h4>{{ method.name + ' - ' + method.days}}</h4>
                                    </div>

                                    <div class="col-md-6 my-2 my-md-0 text-right">
                                        <b-button @click="deleteMethod(i)" size="sm" variant="danger">Удалить</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <b-button ref="add_city" class="mt-3" variant="success" block @click="saveCity">

                <template v-if="action === 'edit'">
                    Сохранить
                </template>
                <template v-if="action === 'add'">
                    Добавить город
                </template>

            </b-button>

        </b-modal>

    </div>


</template>

<script>
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {SET_ALERT} from "../../../core/services/store/alert.module";
    import Paginate from "../Paginate";
    import {ADD_CITY, DELETE_CITY, GET_CITIES, UPDATE_CITY} from "../../../core/services/store/cities.module";
    export default {
        name: "DeliveryCities",
        components: {Paginate},
        mounted(){
            this.$store.dispatch(SET_BREADCRUMB, [{ title: "Города доставки" }]);
            this.getCities()
        },
        data(){
            return{

                filter: {
                    to: '50',
                },

                action: 'add',

                method: {
                  name: '',
                  days: 0,
                  knr: 0,
                  knrrf: 0,
                  tp: 0,
                  rf: 0,
                },

                city: {
                    name: '',
                    methods: []
                },

                modalCity:{
                    name: '',
                    id: null
                },

                errorNameMethod: false
            }
        },

        computed: {

            ...mapGetters({
                paginate: 'paginateGetters',
                cities: 'gettersCities',
                load: 'getCityLoad',
                errors: 'errorsCities'
            })
        },

        methods:{

            titleModal(){
                if (this.action === 'edit') {
                    return 'Редактировать город'
                } else if (this.action === 'add') {
                    return 'Добавить город'
                }
            },

            async getCities(){
                try {
                    await this.$store.dispatch(GET_CITIES, {'page': this.$route.params.page, 'filter': this.filter});
                    if (this.cities.length === 0 && this.paginate.total > 0){
                        this.$router.push({ name: 'DeliveryCities', params: {page: 1}})
                    }
                } catch (e) {
                    this.showAlert('Ошибка загрузки', 'danger', 'toast');
                }
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

            showDelete(site){

                this.modalCity = {
                    name: site.name,
                    id: site.id
                };

                this.$refs['delete-modal'].show();
            },

            closeModal() {
                this.$refs['delete-modal'].hide();

                this.modalCity = {
                    name: '',
                    id: null
                };

            },



            addCityShow(){
                this.action = 'add';
                this.$refs['edit-city'].show();
            },

            async deleteCity(){
                const submitButtonDel = this.$refs["del-city"];
                submitButtonDel.classList.add("spinner", "spinner-light", "spinner-right");

                try {
                    await this.$store.dispatch(DELETE_CITY, this.modalCity.id);
                    this.$refs['delete-modal'].hide();
                    this.getCities();
                    this.modalCity = {
                        name: '',
                        id: null
                    };
                    this.showAlert('Город успешно удален', 'success', 'toast')
                } catch (response) {
                    this.showAlert('Ошибка удаления', 'danger', 'toast');
                } finally {
                    submitButtonDel.classList.remove("spinner", "spinner-light", "spinner-right");
                }


            },

            editCity(city){
                this.action = 'edit';
                this.$refs['edit-city'].show();
                this.city = city
            },

            async saveCity(){
                const submitSave = this.$refs["add_city"];
                submitSave.classList.add("spinner", "spinner-light", "spinner-right");

                if (this.action === 'add') {
                    try {
                        await this.$store.dispatch(ADD_CITY, this.city);
                        this.$refs['edit-city'].hide();
                        this.getCities();
                        this.city = {
                            name: '',
                            methods: []
                        };
                        this.showAlert('Город успешно добавлен', 'success', 'toast')
                    } catch (response) {
                        if (response.status === 422) {
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка добавления города', 'danger', 'toast');
                        }

                    } finally {
                        submitSave.classList.remove("spinner", "spinner-light", "spinner-right");
                    }
                } else if (this.action === 'edit') {

                    try {
                        await this.$store.dispatch(UPDATE_CITY, this.city);
                        this.$refs['edit-city'].hide();
                        this.getCities();
                        this.city = {
                            name: '',
                            methods: []
                        };
                        this.showAlert('Город успешно изменен', 'success', 'toast')
                    } catch (response) {
                        if (response.status === 422) {
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка сохранения города', 'danger', 'toast');
                        }

                    } finally {
                        submitSave.classList.remove("spinner", "spinner-light", "spinner-right");
                    }

                }


            },

            addMethod(){

                this.errorNameMethod = false;

                if (this.method.name){

                    this.city.methods.push(this.method);
                    this.method = {
                      name: '',
                      days: 0,
                      knr: 0,
                      knrrf: 0,
                      tp: 0,
                      rf: 0,
                    }

                } else {

                    this.errorNameMethod = true;
                    this.showAlert('Заполните название метода', 'danger', 'toast');
                }

            },

            deleteMethod(index){
                this.city.methods.splice(index , 1);
            }

        },

        watch: {

            $route: function () {
                this.getCities()
            },

            "filter.to": function() {
                this.getCities()
            },
        }

    }
</script>

<style scoped>

</style>